export default "__VITE_ASSET__so8FB2Ms__"